import React, { useMemo } from "react";

import { Skeleton } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ItemJobCustomerPortal } from "../../../../../../../models/customer.portal";
import { calcTotalItems } from "../../../../../../../util/calcTotalItems";
import { getMeasurement, getWeightMeasurement } from "../../../../../../../util/getMeasurement";
import { Card, CardWrapper, Title, Value } from "./styles";

type TotalCaltulateProps = {
  items: ItemJobCustomerPortal[];
  isLoading: boolean;
  showVolume?: boolean;
  quantity?: number;
  volume?: number;
  weight?: number;
};

export const TotalCalculate: React.FC<TotalCaltulateProps> = ({
  items,
  isLoading,
  showVolume,
  quantity,
  volume,
  weight,
}) => {
  const measurement = getMeasurement();
  const weightMeasurement = getWeightMeasurement();
  const { totalWeight, totalQuantity, totalVolume } = useMemo(
    () => calcTotalItems({ items, measurement, weightMeasurement }),
    [items, weightMeasurement, measurement]
  );

  const { t: translate } = useTranslation();

  return (
    <CardWrapper>
      <Card>
        <Title className="longText">{translate("totalQuantity")}</Title>
        <Title className="shortText">
          {totalQuantity > 1 ? translate("items") : translate("item")}
        </Title>
        {isLoading ? (
          <Skeleton variant="text" width="100%" />
        ) : (
          <Value>{quantity ?? totalQuantity}</Value>
        )}
      </Card>
      {showVolume && (
        <Card>
          <Title className="longText">{translate("totalVolume")}</Title>
          <Title className="shortText">{translate("volume")}</Title>
          {isLoading ? (
            <Skeleton variant="text" width="100%" />
          ) : (
            <Value>{`${volume ?? totalVolume} ${measurement?.code}`}</Value>
          )}
        </Card>
      )}
      <Card>
        <Title className="longText">{translate("totalWeight")}</Title>
        <Title className="shortText">{translate("weight")}</Title>
        {isLoading ? (
          <Skeleton variant="text" width="100%" />
        ) : (
          <Value>{`${weight ?? totalWeight} ${weightMeasurement?.code}`}</Value>
        )}
      </Card>
    </CardWrapper>
  );
};
